import { createContext, useContext } from 'react';
import type { BrowserLogger } from './browser-logger';

export const DiagnosticsContext = createContext<BrowserLogger | null>(null);

export function useDiagnostics(): BrowserLogger {
  const logger = useContext(DiagnosticsContext);
  if (!logger) throw new Error('useDiagnostics must be used inside <DiagnosticsContext.Provider>');
  return logger;
}
